import { render, staticRenderFns } from "./PFGeneralSettings.vue?vue&type=template&id=2ecda79e&scoped=true"
import script from "./PFGeneralSettings.vue?vue&type=script&lang=js"
export * from "./PFGeneralSettings.vue?vue&type=script&lang=js"
import style0 from "./PFGeneralSettings.vue?vue&type=style&index=0&id=2ecda79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecda79e",
  null
  
)

export default component.exports